import React from 'react';
import { MainContentContainer, UnderConstruction } from '@clinicaltoolkits/universal-react-components';

export const About: React.FC = () => {
  return (
    <MainContentContainer>
      <UnderConstruction constructionTarget='About' percentComplete={10} subheadingText="It's about time we got this page finished!" brandName="AI Live" />
    </MainContentContainer>
  );
}
